const Datacards = [
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/cd0a5c342bf93c7bfc0fa8bd144ba938e572157c-800x646.jpg?fm=webp",
        title: "Managing Partner",
        text: "RAVI ADUSUMALLI",
    },
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/5134218d42bf2936efa87e840aa23256e2c01206-6240x4160.jpg?w=960&fm=webp",
        title: "Senior Associate",
        text: "MANISH ADVANI",
    },
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/c2ee4c80119cc3caa9cbf6f3de5beefdb03f0b91-6225x4055.jpg?w=960&fm=webp",
        title: "Associate Vice President",
        text: "AAYUSH AGARWAL",
    },
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/e046fcde46bb13502aad85f8a6c5a402f9b3fae1-800x736.jpg?fm=webp",
        title: "Partner",
        text: "MRIDUL ARORA",
    },
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/75459c088460f18570bfd174534c45fc21e252a1-5690x3793.jpg?w=960&fm=webp",
        title: "Partner",
        text: "MUKUL ARORA",
    },
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/992d314b112ada67a501238603345979c0f98f61-800x631.jpg?fm=webp",
        title: "Associate Vice President",
        text: "CHIRAG CHADHA",
    },
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/17d05e8bd70fd110be9bb070c3cdd6c82157686f-6225x4055.jpg?w=960&fm=webp",
        title: "Investment Analyst",
        text: "SHOURI SRINIVAS CHIKKERUR",
    },
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/90cd82c8811ca5bd60ac40d056947828e973eb1c-5932x3955.jpg?w=960&fm=webp",
        title: "Partner",
        text: "DEEPAK GOUR",
    },
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/5be0c2be1fea212bd6772a916bdeb0ed2f06cb6b-800x704.jpg?fm=webp",
        title: "Advisor",
        text: "ALOK GOEL",
    },
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/7a4eafef98b0d56d10ed11fbc3699b3090b3c88a-5269x3513.jpg?w=960&fm=webp",
        title: "Investment Analyst",
        text: "KSHITIJ JAYAKRISHNAN",
    },
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/6ff130c57113cac248049741f518ca37f2535930-5272x3515.jpg?w=960&fm=webp",
        title: "Investment Analyst",
        text: "SUKRITI JIWARAJKA",
    },
    {
        imgsrc: "https://cdn.sanity.io/images/gxmub2ol/production/02ba8526716e008bd771d8f774733c411c224a88-2536x2903.jpg?w=960&fm=webp",
        title: "Partner",
        text: "MAYANK KHANDUJA",
    },
];
export default Datacards;